import { store } from "../store/store";
//Chamar isto esta a dar bloat, talvez resolvido?
const tryLogin = async () => {
  await store.dispatch("tryLogin");
};
function checkPermission(permission) {
  if (!store.getters.isAuthenticated) {
    tryLogin();
  }

  if (store.getters.isAuthenticated) {
    let rules = store.getters.rules;
    if (typeof permission === "string") {
      if (rules.includes(permission)) {
        return true;
      } else {
        return false;
      }
    } else if (typeof permission === "object") {
      //iterate iver permission and check if all rules are in rules
      for (let i = 0; i < permission.length; i++) {
        if (!rules.includes(permission[i])) {
          return false;
        }
        if (i === permission.length - 1) {
          return true;
        }
      }
    }
  } else {
    return false;
  }

}

export { checkPermission };
